import { call, put, takeLatest, select } from 'redux-saga/effects';
import { isEmpty } from '../../pages/SellerProfile/APIs/Helpers';
import {
    fetchCompanyProfileFailure,
    fetchCompanyProfileStart, fetchCompanyProfileSuccess,
    setDefaultCompData,
    setCompanyName,
    updateCompanyProfileFailure,
    updateCompanyProfileStart,
    updateCompanyProfileSuccess,
    setCompanySubmitt,
    setApiStatus,
    setShowSuccessPopUp
} from '../slices/sellerProfileSlice';
import { PayloadAction } from '@reduxjs/toolkit';
import axios from "axios";
import { apiGetCall ,apiPutCall} from '../api';
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import {showAPIerror} from '../../pages/SellerProfile/APIs/Helpers';
 
const URL = process.env.REACT_APP_API_BASE;
 
function* checkTokenExpired() {
    // if (jwtDecode(token).exp < Date.now() / 1000) {
    yield (window.instance as any)
        .acquireTokenSilent({
            redirectUri: process.env.REACT_APP_AZURE_REDIRECT,
            authority: process.env.REACT_APP_AZURE_AUTHORITY,
        })
        .then((res) => {
            axios.defaults.headers.common["Authorization"] = `Bearer ${res.idToken}`;
        })
        .catch((e) => {
            if (e instanceof InteractionRequiredAuthError) {
                (window.instance as any).loginRedirect();
            }
        });
 
}
 
function* fetchCompanyProfileSaga(action: PayloadAction<{ seller_id: string, language: string }>) {
    try {
 
        yield call(checkTokenExpired);
        const { seller_id, language } = action.payload;
        const res = yield call(apiGetCall, URL + "profile/" + seller_id);
        const finalSellerData = res.data.seller[0];
        const finalContactData = res.data.contact;
 
        yield put(setCompanyName(finalSellerData.company_name));
 
        const defaultCompData = yield select((state: any) => state.sellerProfile.defaultCompData);
 
        let defaultDataToReturn = {};
 
        if (isEmpty(defaultCompData)) {
            const defaultRes = yield call(apiGetCall, URL + "profile-data");
            if (defaultRes && defaultRes.business_model && defaultRes.customer_types && defaultRes.api_schema && defaultRes.pos_type) {
                yield put(setDefaultCompData(defaultRes));
                defaultDataToReturn = defaultRes;
            }
        } else {
            defaultDataToReturn = defaultCompData;
        }
 
        yield put(fetchCompanyProfileSuccess
            ({
                finalSellerData,
                finalContactData,
                defaultCoData: defaultDataToReturn,
                language
            }));
 
    } catch (error: any) {
      const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
            yield put(fetchCompanyProfileFailure(showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'SpAPIgetCompanyProfile')));
    }
}
 
function* updateCompanyProfileSaga(action:PayloadAction<any>){
    try{
        yield call(checkTokenExpired);
        const {formUpdates,language} =action.payload;
        const {compProfile,defaultCompData,seller_id} = yield select((state) => state.sellerProfile);
        const formattedUpdates ={};

        const getValByObjKey = (field, obj) => {
            Object.keys(obj).forEach((key) => {
              if (typeof obj[key] === 'object' && obj[key] !== null && key !== field) {
                getValByObjKey(field, obj[key]);
              } else if (key === field) {
                formattedUpdates[key] = obj[key].content;
              }
            });
        
            return formattedUpdates;
          };

          Object.keys(compProfile).forEach((origKey) => {
            getValByObjKey(origKey,formUpdates['editCompanyProfile']);
          });
        
          const updatedPOStype: string[] = [];
        
          const getPOStype = formattedUpdates['pos_type'];
          const getPOSother = formattedUpdates['otherPOS'];

          defaultCompData?.pos_type?.forEach((pos) => {
            const posCountry = language === "fr" ? pos.pays : pos.country;
            getPOStype?.includes(posCountry) && updatedPOStype.push(pos.pos_code);
            getPOSother?.includes(posCountry) && updatedPOStype.push(pos.pos_code);
          });
        
          formattedUpdates['pos_preference'] = updatedPOStype;

          const requiredUpdateFields = [
            'company_name',
            'company_address',
            'company_website',
            'business_contact_first_name',
            'business_contact_last_name',
            'business_phone_no',
            'business_email',
            'contact',
            'customer_type_id',
            'business_model_id',
            'implementation_start_date',
            'pos_preference',
            'api_schema_version',
            'iata_number'
          ];

           //Format customer type (switch to code)
  const getCusType = formattedUpdates['customer_type'];
  const translatedCustomerType = language === "fr"
    ? 'customer_type_fr'
    : 'customer_type';
  defaultCompData?.customer_types?.forEach((cType) => {
    getCusType?.includes(cType[translatedCustomerType]) &&
      (formattedUpdates['customer_type_id'] = cType.customer_type_id);
  });

  //Format bizmodel (switch to code)
  const getBizModel = formattedUpdates['business_model_type'];
  const translatedBizModelType = language === "fr"
    ? 'business_model_type_fr'
    : 'business_model_type';
  let bizModels: string[] = [];
  getBizModel.map((value) => {
    defaultCompData?.business_model?.forEach((bMod) => {
      if (value?.includes(bMod[translatedBizModelType]))
        bizModels.push(bMod.business_model_id);
    });
    return null;
  });

  formattedUpdates['business_model_id'] = bizModels;

  //Format contact
  const contactsFields = [
    'contact_first_name',
    'contact_last_name',
    'contact_phone',
    'contact_email',
    'contact_id'
  ];
  const contactsTypes = ["admin"];
  const updatedContacts: any = [];
  contactsTypes.forEach((conType, i) => {
   const updatedContact: any = {};
    contactsFields.forEach((field) => {
      const getContactData =
        field === 'contact_id'
          ? compProfile[`${conType}_${field}`]
          : formattedUpdates[`${conType}_${field}`];
          if(Array.isArray(getContactData)){
            updatedContact[`${field}`] = getContactData[0]?.replaceAll('null', '');
          }else{
            updatedContact[`${field}`]=getContactData?.replaceAll('null','');
          }
     
    });
    updatedContacts.push(updatedContact);
  });

  formattedUpdates['contact'] = updatedContacts;

  const fieldsToConvert = [
    'business_contact_first_name',
    'business_contact_last_name',
    'business_email',
    'business_phone_no',
    'company_address',
    'company_name',
    'company_website',
    'iata_number'
  ];
   
  fieldsToConvert.forEach((field) => {
    if (Array.isArray(formattedUpdates[field])) {
      formattedUpdates[field] = formattedUpdates[field][0];
    }
  });

  Object.keys(formattedUpdates).forEach((field) => {
    !requiredUpdateFields.includes(field) && delete formattedUpdates[field];
  });

  const formatDate = new Date(
    formattedUpdates['implementation_start_date']
  ).toISOString();
  formattedUpdates['implementation_start_date'] = formatDate;


  const response = yield call(apiPutCall,URL + 'profile/' + seller_id,formattedUpdates);
  if(response.status === 'successful'){
    yield put(updateCompanyProfileSuccess(response));
    yield put (setCompanyName(formattedUpdates['company_name']));
    yield put(setCompanySubmitt(true));
  }
    }catch(error:any){
       const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
        yield put(updateCompanyProfileFailure(showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'SpAPIUpdateCompanyProfile')));
    }
}
 
export default function* companyProfileSaga() {
    yield takeLatest(fetchCompanyProfileStart.type, fetchCompanyProfileSaga);
    yield takeLatest(updateCompanyProfileStart.type, updateCompanyProfileSaga);
}
 
